// export ncSystem from './modules/system'
// export ncUser from './modules/user'
// export ncRefresh from './modules/refresh';
import ncMedia from "./modules/media";
import ckPlayer from "./modules/ckPlayer";
import assessment from "./modules/assessment";
import special from "./modules/special";

export default [ncMedia, ckPlayer, assessment, special];
